import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'appImageUrl'
})
export class AppImageUrlPipe implements PipeTransform {
  public transform(imageName: string, size?: number): string {
    if (!imageName) {
      return '';
    }
    return imageName.startsWith('http')
      ? this.transformUrl(imageName, size)
      : this.transformImageId(imageName, size);
  }

  private transformUrl(url: string, size?: number): string {
    if (!size) {
      return url;
    }
    const [base, query] = url.split('?');
    const baseNoExt = this.removeExtension(base);
    const separator = query ? `?${query}&` : '?';
    return `${baseNoExt}${separator}size=${size}`;
  }

  private transformImageId(imageId: string, size?: number): string {
    const baseName = this.removeExtension(imageId);
    const url = `${environment.backendBaseUrl}/images/${baseName}`;
    return size ? `${url}?size=${size}` : url;
  }

  private removeExtension(path: string): string {
    return path.replace(/\.[^./]+$/, '');
  }
}
